import image_0 from '~/assets/screenshots/tasks/id-229-locale-es.png';
import image_1 from '~/assets/screenshots/tasks/id-99-locale-es.png';
import image_2 from '~/assets/screenshots/tasks/id-971-locale-es.png';
import image_3 from '~/assets/screenshots/tasks/id-961-locale-es.png';
import image_4 from '~/assets/screenshots/tasks/id-621-locale-es.png';
import image_5 from '~/assets/screenshots/tasks/id-6-locale-es.png';
import image_6 from '~/assets/screenshots/tasks/id-1133-locale-es.png';
import image_7 from '~/assets/screenshots/tasks/id-1010-locale-es.png';
import image_8 from '~/assets/screenshots/tasks/id-1040-locale-es.png';

export default {229: image_0,99: image_1,971: image_2,961: image_3,621: image_4,6: image_5,1133: image_6,1010: image_7,1040: image_8};